/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SsoimageStatuses200,
  GetApiV1SsoimageStatuses401,
  GetApiV1SsoimageStatuses500,
  GetApiV1SsoimageStatusesQueryResponse,
} from "../../types/SSOImageController/GetApiV1SsoimageStatuses.ts";
import { SSOEnumItemViewModelSchema } from "../SSOEnumItemViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SsoimageStatuses200Schema = z.array(
  z.lazy(() => SSOEnumItemViewModelSchema),
) as unknown as ToZod<GetApiV1SsoimageStatuses200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SsoimageStatuses401Schema =
  z.any() as unknown as ToZod<GetApiV1SsoimageStatuses401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SsoimageStatuses500Schema =
  z.any() as unknown as ToZod<GetApiV1SsoimageStatuses500>;

export const getApiV1SsoimageStatusesQueryResponseSchema = z.lazy(
  () => getApiV1SsoimageStatuses200Schema,
) as unknown as ToZod<GetApiV1SsoimageStatusesQueryResponse>;
